export default function ThinkingMachinesLogo() {
  return <img src="/logos/thinking-machines-logo.jpeg" alt="Thinking Machines" width="16" height="16" className="block" />
}
